<template>
    <div class="ai-interactions-content">
        <div
            v-for="(interaction, index) in sortedInteractions"
            :key="index"
            class="ai-interactions-content__item"
        >
            <div
                class="ai-interactions-content__item-header typographies-paragraph-medium-semibold"
            >
                <CompassAvatar
                    :initials="getInitials(interaction.user)"
                    size="extra-small"
                    :colorType="getAvatarColor(interaction.user)"
                />
                {{ interaction.user.firstname }} {{ interaction.user.lastname }}
            </div>
            <p class="ai-interactions-content__item-summary">{{ interaction.summary }}</p>
            <div class="ai-interactions-content__item-date typographies-paragraph-medium-regular">
                <CompassIcon icon="calendar" size="small" />
                {{ formatDate(interaction.date) }}
            </div>
        </div>
        <NoInvoicingData
            v-if="hasNoData"
            :content="$t.__('overview.tabs.TabSummary.noInteractionData')"
        />
    </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { randAvatarColorFullname } from 'utils/avatar';
import NoInvoicingData from 'vcomponents/AISummary/Content/NoInvoicingData.vue';

const { mapState: corpMapState } = createNamespacedHelpers('corp');

export default {
    components: {
        NoInvoicingData,
    },
    inject: ['getSummary'],
    computed: {
        ...corpMapState(['timeformat']),
        summary() {
            return this.getSummary();
        },
        latestInteractions() {
            return this.summary ? this.summary.summary.output.latest_interactions : [];
        },
        sortedInteractions() {
            const sortedArray = [...this.latestInteractions].sort((a, b) => {
                return new Date(b.date) - new Date(a.date);
            });

            if (sortedArray.length < 5) {
                return sortedArray;
            } else {
                return sortedArray.slice(0, 5);
            }
        },
        hasNoData() {
            return !this.latestInteractions || this.latestInteractions.length === 0;
        },
    },
    methods: {
        formatDate(date) {
            return this.timeformat === 'dmy'
                ? moment(date).format('DD/MM/YYYY')
                : moment(date).format('MM/DD/YYYY');
        },
        getAvatarColor(person) {
            return randAvatarColorFullname(`${person.firstname} ${person.lastname}`);
        },
        getInitials(person) {
            return `${person.firstname.charAt(0)}${person.lastname.charAt(0)}`;
        },
    },
};
</script>
<style lang="scss" scoped>
.ai-interactions-content {
    &__item {
        & + & {
            border-top: 1px solid var(--colors-common-border-lighter);
            margin-top: var(--spacing-3);
            padding: var(--spacing-3) 0 0;
        }

        &-header {
            align-items: center;
            display: flex;
            gap: var(--spacing-1);
            margin: 0 0 var(--spacing-1);
        }

        &-summary {
            margin: 0 0 var(--spacing-1);
        }

        &-date {
            align-items: center;
            color: var(--colors-common-text-standard-caption);
            display: flex;
            gap: var(--spacing-1);
        }
    }
}
</style>
